import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import {WrapperSearchInput, WrapperSearchList} from "../ModalAddChat/components";
import Icon from "../../Common/Icon";
import Button from "../../Common/Button";
import InputText from "../../FormFields/Text";
import ChatUserRowOption from "../ChatUserRowOption";
import ChatUserSelected from "../ChatUserSelected";
import ConfigService from "../../../Services/api/Config";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";

class ModalAddPeopleChat extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state= {
      lastSearch: '',
      members: [],
      membersSelected: [],
      recentMembers: [],
      init: false,
    };
  }

  onPressClose = (event) => this.props.onClose(event);

  onPressSave = async (event) => {
    const { membersSelected } = this.state;
    if (membersSelected.length > 0) {
      this.props.onSubmit(membersSelected);
      this.props.onClose(event);
    }
  };

  setRecentMembers = async () => {
    const { membersSelected } = this.state;
    const { searchRecentList, excludeMembers } = this.props;
    const search = await searchRecentList([...excludeMembers, ...membersSelected]);
    this.setState({
      recentMembers: search && search.users ? search.users : [],
      init: true,
    });
  };

  searchUserList = async (name) => {
    const { membersSelected } = this.state;
    const { searchUserList, excludeMembers } = this.props;
    if (name) {
      const search = await searchUserList(name, [...excludeMembers, ...membersSelected]);
      this.setState({
        lastSearch: name,
        members: search.users,
      });
    }
    else {
      this.setState({
        lastSearch: name,
        members: [],
      });
    }
  };

  onAddUser = (user) => {
    const { membersSelected, lastSearch } = this.state;
    let index = -1;
    membersSelected.forEach((member, key) => {
      if (user.id === member.id) {
        index = key;
      }
    });
    if (index >= 0) {
      membersSelected.splice(index, 1);
    }
    else {
      membersSelected.push(user);
    }
    this.setState({
      membersSelected: [...membersSelected]
    });
    this.searchUserList(lastSearch);
    this.setRecentMembers();
  };

  renderItem = (user) => {
    return (
      <ChatUserRowOption
        key={user.id}
        user={user}
        onClick={ this.onAddUser }
      />
    )
  };

  renderItemSelected = (user) => {
    return (
      <ChatUserSelected
        key={user.id}
        user={user}
        onClick={ this.onAddUser }
      />
    )
  };

  render() {

    const { members, membersSelected, recentMembers, init } = this.state;

    if (!init) {
      this.setRecentMembers();
    }

    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Add Channel'
        className='Modal_Content'
        overlayClassName='Modal_Overlay Modal_Overlay_Chat'
      >
        <div className='Modal_Content_Container'>
          <h2>
            Add People
          </h2>
          <div className='Content'>
            <WrapperSearchInput className='Table' borderInputColor={ ConfigService.getColor('tertiaryColor', 0.4)}>
              <div className="TableCell CellInput">
                <InputText
                  className='Input-Search'
                  placeholder='Search person'
                  onChange={ this.searchUserList }
                />
              </div>
              <div className="TableCell">
                <Button className="Button_Small" onClick={this.onPressSave}>
                  Add People
                </Button>
              </div>
            </WrapperSearchInput>
            { membersSelected.length > 0 &&
              <WrapperSearchList>
                { membersSelected.map((user) => this.renderItemSelected(user))}
              </WrapperSearchList>
            }
            { members.length > 0 &&
              <WrapperSearchList>
                { members.map((user) => this.renderItem(user))}
              </WrapperSearchList>
            }
            { members.length === 0 &&
              <WrapperSearchList textColor={ ConfigService.getColor('tertiaryColor', 0.8)}>
                <div className="Subtitle">Recent</div>
                { recentMembers.map((user) => this.renderItem(user))}
              </WrapperSearchList>
            }
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
              <CloseIcon alt='icon-close'/>
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalAddPeopleChat.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModalAddPeopleChat;
